export default [
  {
    tip:
      "Try to tap your foot on the 1/4 note pulses. With your other hand, tap the rhythm you see."
  },
  {
    tip: "Begin subdividing into 8th notes during the 4-beat count-in."
  },
  {
    tip:
      "Look for obvious differences.  If you see one or more Rests in the measure but the pattern sounds full, that gives you a clue. Or maybe you notice that one answer starts on the downbeat while the other has a Rest."
  },
  {
    tip:
      "After you hear the rhythm, try verbally counting it(verbalizing it?). For example: 1 and 2 and _ _ 4 and"
  },
  {
    tip: "Symbols for 8th and whole note rests"
  },
  {
    tip: "Tap your foot or clap on 1/4 notes to keep your place in the measure."
  }
];

/* 
IDEAS:

Goal of the game:
    Identify the visual representation of what I'm hearing

Student:
    Inexperienced reading rhythms
    
*/
